import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

export const loginWithEmail = createAsyncAction(
  '/account/LOGIN_WITH_EMAIL_BEGIN',
  '/account/LOGIN_WITH_EMAIL_SUCCESS',
  '/account/LOGIN_WITH_EMAIL_FAILURE'
)<{ email: string; password: string }, { userId: number; token: string }, Error>()

export const changePasswordBegin = createAction(
  '/account/CHANGE_PASSWORD_BEGIN',
  (resolve) => (email: string, password: string, token: string, redirectPath?: string) =>
    resolve({ email, password, token, redirectPath })
)

export const changePasswordSuccess = createAction('/account/CHANGE_PASSWORD_SUCCESS')

export const changePasswordFailure = createAction('/account/CHANGE_PASSWORD_FAILURE')

export const resetPasswordBegin = createAction('/account/RESET_PASSWORD_BEGIN', (resolve) => (email: string) =>
  resolve({ email })
)

export const resetPasswordSuccess = createAction('/account/RESET_PASSWORD_SUCCESS')

export const resetPasswordFailure = createAction('/account/RESET_PASSWORD_FAILURE')

export type AccountPageAction = ActionType<
  | typeof loginWithEmail
  | typeof resetPasswordBegin
  | typeof resetPasswordSuccess
  | typeof resetPasswordFailure
  | typeof changePasswordBegin
  | typeof changePasswordSuccess
  | typeof changePasswordFailure
>
